import { LanguageSelector } from '@plone/volto/components';
import './InternetHeaderVlaanderen.scss';
import { useIntl, defineMessages } from 'react-intl';
import ProgressBar from '../ProgressBar';

const messages = defineMessages({
  flandershead: {
    id: 'flandershead',
    defaultMessage: 'Flanders',
  },
  needhelp: {
    id: 'Need help',
    defaultMessage: 'Need help',
  },
  needhelpcontactus: {
    id: 'Need help? Contact us',
    defaultMessage: 'Need help? Contact us',
  },
});

const InternetHeaderVlaanderen = () => {
  const intl = useIntl();
  // const sitemap = intl.locale === 'en' ? sitemapEN : sitemapNL;
  return (
    <div className="vlw-wrapper">
      <div className="tools-wrapper">
        <div id="headerVlaanderen">
          <div className="fl-logo">
            <svg
              id="headerLogo"
              width="19"
              height="32"
              viewBox="0 0 19 32"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M18.6457 16.4224C17.6348 15.5944 17.1294 16.4224 16.4723 16.3706C15.9164 16.3189 15.4109 15.4392 15.0066 15.6462C14.1979 16.0602 15.3098 17.5608 15.8153 17.8712C16.2702 18.1299 16.8261 18.3887 16.9272 18.4404C17.5843 18.7509 17.837 19.2166 17.9381 19.941C17.9381 20.0963 17.9381 20.5102 17.8875 20.6654C17.5843 21.9591 15.3604 23.1492 14.0968 22.2178C13.4903 21.8038 12.9343 21.2346 12.7827 20.3032C12.4289 18.5957 11.2664 17.3538 10.862 15.6979C10.6093 14.7148 10.4577 13.6281 10.205 12.5932C9.95225 11.5583 9.69953 10.5234 9.44682 9.5403C9.24464 8.66063 8.8403 7.31527 8.53704 6.53909C7.324 3.27916 6.76802 3.53789 6.76802 3.53789C6.76802 3.53789 7.22291 4.41755 8.78975 12.3863C8.8403 12.6967 9.44681 16.2154 9.85116 17.3538C10.0028 17.7677 10.2555 18.6474 10.4577 19.0096C10.9631 20.148 12.3278 21.8556 12.3783 23.4079C12.4289 24.2876 12.53 25.0638 12.53 25.7364C12.53 25.9434 12.631 26.7196 12.7321 27.0818C13.0859 28.0132 15.7142 31.0662 18.5446 31.0662V28.7376C15.7647 28.7376 13.0859 27.1336 13.0354 26.9783C12.9848 26.9266 13.187 25.7882 13.3892 25.3225C13.743 24.3911 14.4506 23.5114 15.6636 23.4079C17.0283 23.3044 17.837 23.7184 18.5446 23.7184L18.6457 16.4224ZM6.46476 8.0397C6.36367 9.79902 3.73542 12.1275 2.92673 13.6799C2.52238 14.4043 2.01695 15.6979 1.91586 16.4224C1.56206 18.4922 2.01695 19.7858 2.52238 20.9759C3.38162 23.0975 2.37075 23.9254 3.02782 23.4597C3.88705 22.7352 3.73542 21.1312 3.68488 20.0963C3.63434 19.2683 3.58379 18.3369 3.68488 17.3538C3.9376 15.491 4.999 13.5247 5.95933 12.1275C7.07128 10.5234 6.66693 8.76412 6.46476 8.0397ZM7.02074 12.9555C7.02074 12.9555 7.324 14.3526 6.11096 17.8712C2.97727 27.0818 8.89084 27.9615 10.6093 30.1348C10.6093 30.1348 11.2664 29.2034 8.58758 26.2022C7.62726 25.1155 6.71748 22.6835 7.47563 19.2166C8.58758 14.1973 7.02074 12.9555 7.02074 12.9555ZM1.15771 6.90131C1.00608 6.33211 0.95554 5.86641 1.00608 5.40071C1.15771 3.22742 3.07836 2.34776 3.53325 2.03729C3.53325 2.03729 4.39248 1.41635 4.49357 0.79541C4.49357 0.79541 5.40335 3.07219 3.33108 4.36581C2.32021 5.09024 1.66315 5.86641 1.15771 6.90131ZM6.00987 4.77977C6.11096 4.98675 6.91965 6.17688 3.63434 8.9711C0.34902 11.7136 1.41043 13.6799 1.41043 13.6799C1.41043 13.6799 -2.07706 11.7136 1.91586 8.24667C5.90878 4.83151 5.10009 4.10708 5.10009 4.10708C5.10009 4.10708 5.70661 4.15883 6.00987 4.77977ZM10.2555 5.86641C10.8115 5.91815 11.1653 7.72922 12.4794 8.14318C13.4397 8.45365 14.4506 8.29842 14.7033 8.86761C14.2484 9.12634 14.6022 9.90251 15.0571 9.74728C15.4109 8.71238 15.5626 4.62453 10.2555 5.86641ZM12.0245 6.64258C12.0751 6.53909 12.1256 6.64258 12.2772 6.53909C12.4289 6.38386 12.5805 6.12513 12.8332 6.07339C13.0354 6.02164 13.2376 6.02164 13.4397 6.12513C13.5408 6.17688 13.4903 6.4356 13.3892 6.53909C13.2376 6.69433 12.6816 6.4356 12.6816 6.84956C12.6816 7.52225 13.5408 6.84956 13.9957 6.84956C14.1979 8.40191 11.6202 7.98795 12.0245 6.64258Z"
                fill="#333332"
              />
            </svg>
            <svg
              width="17"
              height="45"
              viewBox="0 0 17 45"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <line
                x1="0.499194"
                y1="0.909207"
                x2="16.4408"
                y2="44.7486"
                stroke="#D2D8DF"
              />
            </svg>

            <a
              href="https://vlaanderen.be"
              id="headerTitleVlaanderen"
              aria-label={intl.formatMessage(messages.flandershead)}
              target="_blank"
              rel="noreferrer"
            >
              {intl.formatMessage(messages.flandershead)}
            </a>
          </div>
          <svg
            width="9"
            height="23"
            viewBox="0 0 9 23"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <line
              x1="0.469897"
              y1="0.829128"
              x2="8.4699"
              y2="22.8291"
              stroke="#D2D8DF"
            />
          </svg>

          <a
            href={
              intl.locale === 'en'
                ? 'https://en.vmm.vlaanderen.be'
                : 'https://vmm.vlaanderen.be'
            }
            id="headerUrlVmm"
            aria-label="VMM"
          >
            {intl.locale === 'en'
              ? 'en.vmm.vlaanderen.be'
              : 'vmm.vlaanderen.be'}
          </a>
        </div>

        <div id="requireHelp-wrapper">
          {intl.locale !== 'en' && (
            <a
              href="https://www.burgerprofiel.be"
              id="myProfile"
              target="_blank"
              aria-label="Burgerprofiel"
              rel="noreferrer"
            >
              <svg
                width="24"
                height="23"
                viewBox="0 0 24 23"
                aria-hidden="true"
                className="citizenLogo"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g fillRule="evenodd">
                  <path d="M22 2h-4.59l-3 3H2v12h2.21v2H0V3h13.59l3-3H24v18.97h-2V2z" />
                  <path d="M13 8.99a2.52 2.52 0 1 0 0 5.03 2.52 2.52 0 0 0 0-5.03M13 16a4.52 4.52 0 1 1 .01-9.03A4.52 4.52 0 0 1 13 16m-5.97 6.4l-1.45-1.38a10.29 10.29 0 0 1 7.49-3.19 10.3 10.3 0 0 1 7.33 3.04L19 22.3a8.32 8.32 0 0 0-5.92-2.46 8.3 8.3 0 0 0-6.04 2.58" />
                </g>
              </svg>
              <span>Mijn burgerprofiel</span>
            </a>
          )}
          <div className="arrow-up"></div>

          <div id="requireHelp">
            <a
              href="/contact"
              alt="Contact"
              aria-label={intl.formatMessage(messages.needhelpcontactus)}
            >
              {intl.formatMessage(messages.needhelp)}
            </a>
            <svg
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M10.0001 20C7.42525 19.8848 4.9941 18.7809 3.21281 16.9182C1.43152 15.0554 0.437378 12.5774 0.437378 10C0.437378 7.42263 1.43152 4.94458 3.21281 3.08182C4.9941 1.21907 7.42525 0.115177 10.0001 0C12.5749 0.115177 15.006 1.21907 16.7873 3.08182C18.5686 4.94458 19.5627 7.42263 19.5627 10C19.5627 12.5774 18.5686 15.0554 16.7873 16.9182C15.006 18.7809 12.5749 19.8848 10.0001 20ZM10.0001 2C7.87832 2 5.84349 2.84285 4.3432 4.34315C2.84291 5.84344 2.00005 7.87827 2.00005 10C2.00005 12.1217 2.84291 14.1566 4.3432 15.6569C5.84349 17.1571 7.87832 18 10.0001 18C12.1218 18 14.1566 17.1571 15.6569 15.6569C17.1572 14.1566 18.0001 12.1217 18.0001 10C18.0001 7.87827 17.1572 5.84344 15.6569 4.34315C14.1566 2.84285 12.1218 2 10.0001 2ZM11.0001 13H9.00005V10H10.0001C10.3956 10 10.7823 9.8827 11.1112 9.66294C11.4401 9.44318 11.6964 9.13082 11.8478 8.76537C11.9992 8.39991 12.0388 7.99778 11.9616 7.60982C11.8845 7.22186 11.694 6.86549 11.4143 6.58579C11.1346 6.30608 10.7782 6.1156 10.3902 6.03843C10.0023 5.96126 9.60014 6.00087 9.23469 6.15224C8.86923 6.30362 8.55688 6.55996 8.33711 6.88886C8.11735 7.21776 8.00005 7.60444 8.00005 8H6.00005C6.00136 7.25216 6.21229 6.51967 6.6089 5.88567C7.00551 5.25166 7.5719 4.74154 8.2438 4.41319C8.9157 4.08484 9.66619 3.95143 10.4101 4.02809C11.154 4.10475 11.8615 4.38842 12.4523 4.84689C13.0431 5.30536 13.4936 5.92028 13.7526 6.62184C14.0115 7.32341 14.0686 8.08352 13.9174 8.81591C13.7662 9.54829 13.4127 10.2236 12.897 10.7652C12.3813 11.3068 11.7241 11.693 11.0001 11.88V13ZM10.0001 16.25C9.66853 16.25 9.35059 16.1183 9.11617 15.8839C8.88175 15.6495 8.75005 15.3315 8.75005 15C8.75005 14.6685 8.88175 14.3505 9.11617 14.1161C9.35059 13.8817 9.66853 13.75 10.0001 13.75C10.3316 13.75 10.6495 13.8817 10.8839 14.1161C11.1184 14.3505 11.2501 14.6685 11.2501 15C11.2501 15.3315 11.1184 15.6495 10.8839 15.8839C10.6495 16.1183 10.3316 16.25 10.0001 16.25Z"
                fill="white"
              />
            </svg>
          </div>
        </div>
        <LanguageSelector />

        <ProgressBar />
      </div>
    </div>
  );
};

export default InternetHeaderVlaanderen;
